// Stripe configuration
export const STRIPE_CONFIG = {
  // Publishable key - this is safe to expose in the frontend
  publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_51Rv4ol0n8aeM4Uk40FfeYE5wiW6rcfDkTkBQUSHcTGESrRv9zEV7mi6hLgG3kT5mekexpA3KGmfbk9S5Fvanjt1g00AsCpsAc5',
  
  // Currency and payment settings
  currency: 'usd',
  
  // Payment amounts
  serviceProviderUpgrade: 9900, // $99.00 in cents
  propertyOwnerTrial: 0, // Free trial, no charge
  
  // Payment descriptions
  serviceProviderUpgradeDescription: 'EasyProperty Service Provider Premium Upgrade',
  propertyOwnerTrialDescription: 'EasyProperty Property Owner Trial',
  
  // Success/error URLs
  successUrl: `${window.location.origin}/dashboard`,
  cancelUrl: `${window.location.origin}/dashboard`,
};

// Stripe Elements configuration
export const STRIPE_ELEMENTS_CONFIG = {
  mode: 'payment',
  currency: STRIPE_CONFIG.currency,
  appearance: {
    theme: 'stripe',
    variables: {
      colorPrimary: '#3b82f6',
      colorBackground: '#ffffff',
      colorText: '#1f2937',
      colorDanger: '#ef4444',
      fontFamily: 'Inter, system-ui, sans-serif',
      spacingUnit: '4px',
      borderRadius: '8px',
    },
  },
};

// Validate Stripe configuration
export const validateStripeConfig = () => {
  const key = STRIPE_CONFIG.publishableKey;
  
  if (!key || key === 'pk_test_your_test_key_here') {
    console.error('❌ Stripe Configuration Error:');
    console.error('   Please set your Stripe publishable key in .env.local:');
    console.error('   REACT_APP_STRIPE_PUBLISHABLE_KEY=pk_test_your_actual_key_here');
    console.error('');
    console.error('   To get your key:');
    console.error('   1. Go to https://dashboard.stripe.com/apikeys');
    console.error('   2. Copy your publishable key (starts with pk_test_)');
    console.error('   3. Create .env.local file in project root');
    console.error('   4. Add the key and restart your development server');
    console.error('');
    console.error('   Current key:', key);
    
    return false;
  }
  
  if (!key.startsWith('pk_test_') && !key.startsWith('pk_live_')) {
    console.error('❌ Invalid Stripe key format:', key);
    console.error('   Key should start with pk_test_ or pk_live_');
    return false;
  }
  
  console.log('✅ Stripe configuration validated successfully');
  return true;
};

// Debug logging
console.log('Stripe Config:', {
  publishableKey: STRIPE_CONFIG.publishableKey,
  keyLength: STRIPE_CONFIG.publishableKey?.length,
  keyStartsWith: STRIPE_CONFIG.publishableKey?.substring(0, 7),
  envVar: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
  isValid: validateStripeConfig()
});
